<template>
  <v-footer
    id="dashboard-core-footer"
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >
        <!-- <v-col
          v-for="(link, i) in links"
          :key="i"
          class="text-center mb-sm-0 mb-5"
          cols="auto"
        >
          <a
            :href="link.href"
            class="mr-0 grey--text text--darken-3"
            rel="noopener"
            target="_blank"
            v-text="link.text"
          />
        </v-col> -->

        <v-spacer class="hidden-sm-and-down" />

        <v-col
          cols="3"
          md="auto"
        >
          <v-btn
            id="idSuport"
            :color="corPrimaria"
            dark
            class="col-8 col-sm-9"
            target="_blank"
            :href="whatsapp"
          >
            <v-icon
              id="iconSuport"
              color="#ffffff"
            >
              mdi-account-question
            </v-icon>
            <h5>SUPORTE</h5>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-row justify="center">
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="600px"
        @keydown.esc="close()"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="close()"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <!-- <v-img
              id="iconImg"
              src="../../../../assets/campanela.png"
              contain
              style="opa"
            /> -->
            <h3 :style="styleObject">
              {{ dialog.message }}
            </h3>
          </v-card-text>
          <v-card-text
            class="pb-3 pt-6 text-center"
            :style="styleObject"
          >
            <h4>Nos envie sua dúvida ou sugestão.</h4>
            <v-container>
              <v-form
                ref="form"
                @submit.prevent="sendEmail"
              >
                <v-row>
                  <v-col
                    cols="5"
                    class="center"
                  >
                    <v-select
                      v-model="select"
                      :items="types"
                      item-value="id"
                      item-text="text"
                      label="Título do email"
                      return-object
                    />
                  </v-col>
                  <v-col>
                    <tex-field-with-validation
                      v-model="mail.subject"
                      rules="required"
                      type="text"
                      label="Assunto"
                    />
                  </v-col>
                </v-row>
                <v-container fluid>
                  <v-textarea
                    v-model="mail.body"
                    counter
                    solo
                    height="200"
                    label="Texto"
                    :rules="rules"
                    :value="value"
                    @keyup.enter="loader = 'loading', sendEmail()"
                  />
                </v-container>
                <v-btn
                  id="btnSend"
                  :color="corPrimaria"
                  :loading="loading"
                  :disabled="loading"
                  class="ma-2 col-3 col-sm-3"
                  @click="loader = 'loading', sendEmail()"
                >
                  <v-icon
                    id="iconSend"
                    color="#ffffff"
                  >
                    mdi-email-sync-outline
                  </v-icon>
                  <h4>Enviar</h4>
                  <template v-slot:loader>
                    <span>Enviando Email...</span>
                  </template>
                </v-btn>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-footer>
</template>

<script>
  import {
    mapState,
  } from 'vuex'
  import SendEmail from '../../../../services/sendemail'
  export default {
    name: 'DashboardCoreFooter',
    components: {
      DashboardCoreSnackbar: () => import('./Snackbar'),
    },

    data: () => ({
      dialog: {
        visible: false,
        message: '',
      },
      select: {},
      types: [
        { id: 1, text: 'Falha' },
        { id: 2, text: 'Dúvidas' },
        { id: 3, text: 'Sugestões' },
      ],
      rules: [v => v.length <= 500 || 'Quantidade máxima caracteres 500'],
      value: '',
      mail: {
        subject: '',
        body: '',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      tokencontrato: localStorage.tokencontrato,
      email: localStorage.email,
      whatsapp: 'https://wa.me/55' + localStorage.whatsapp,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loader: null,
      loading: false,
    }),

    computed: {
      ...mapState(['versao']),
    },

    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 25000)

        this.loader = null
      },
    },

    methods: {
      async sendEmail () {
        await SendEmail.send(this.email, this.mail, this.select, this.tokencontrato).then(resposta => {
          if (!resposta.data.status) {
            this.showSnackbar('error', 3000, resposta.data.msg)
          } else {
            this.showSnackbar('success', 3000, resposta.data.msg)
            this.dialog.visible = false
            this.select = {}
            this.mail = {}
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      showModal () {
        this.showDialog('Fale conosco.')
      },

      close () {
        this.dialog.visible = false
        this.select = {}
        this.mail = {}
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase

  #idSuport
    border-radius: 1.8rem

  #iconSuport
    margin-right: 0.3rem

  #btnSend
    border-radius: 1.5rem

  #iconSend
    margin-right: 0.3rem

  .custom-loader
    animation: loader 1s infinite
    display: flex

  #iconImg
    height: 4.6em
    width: 9em
    position: absolute

  @-moz-keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

  @-webkit-keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

  @-o-keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

  @keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

</style>
